import { Deferred } from "@/utils/Deferred";
import { modelState } from "@/utils/modelState";
import { ReservationExistingPerson } from "@/EditReservation/model.ReservationPerson";
import { ReservationPerson, ReservationContact, ReservationCompany, ReservationExistingCompany } from "@/EditReservation/types";
export interface CreditsState {
    creditId: string | null;
    selectedContact: modelState<ReservationContact | null>;
    amount: number | null;
    expiresOn: Date | null;
    notes: string | null;
    transactions: CreditTransaction[];
}

let globalModel: CreditsState | undefined;
let modelDeferred = new Deferred<CreditsState>();

export function setGlobalModel(model: CreditsState) {
    if (!globalModel) {
        globalModel = model;
        modelDeferred = new Deferred<CreditsState>();
    } else {
        modelDeferred = new Deferred<CreditsState>();
    }
    modelDeferred.resolve(model);
}

export async function getGlobalModel(): Promise<CreditsState> {
    return modelDeferred.promise;
}

export async function fetchModel(url: string): Promise<CreditsState> {
    const response = await fetch(url);
    const credit = await response.json();

    let contact: modelState<ReservationContact | null>;
    
    if (credit.personId) {
        const existingPerson: ReservationExistingPerson = {
            [ReservationPerson]: true,
            [ReservationExistingPerson]: true,
            PersonId: credit.personId,
            ContactId: null
        };
        contact = modelState(existingPerson as any);
    } else if (credit.companyId) {
        const existingCompany: ReservationExistingCompany = {
            [ReservationCompany]: true,
            [ReservationExistingCompany]: true,
            CompanyId: credit.companyId,
            ContactId: null
        };
        contact = modelState(existingCompany as any);
    } else {
        contact = modelState(null);
    }

    return {
        creditId: credit.creditId,
        selectedContact: contact,
        amount: credit.amount,
        expiresOn: new Date(credit.expiresOnUtc),
        notes: credit.notes,
        transactions: credit.transactions.map((t: CreditTransactionDto) => {
            return {
                type: t.type,
                amount: t.amount,
                createdUtc: new Date(t.createdUtc),
                reference: t.reference,
                user: t.user
            };
        })
    };
}

export interface CreditTransactionDto {
    type: string;
    amount: number;
    createdUtc: string;
    reference: string;
    user: string;
}

export interface CreditTransaction {
    type: string;
    amount: number;
    createdUtc: Date;
    reference: string;
    user: string;
}

export interface CreditTransferState {
    sourceCreditId: string;
    sourceContactName: string;
    sourceAmount: number;
    selectedRecipient: modelState<ReservationContact | null>;
    amount: number | null;
    note: string | null;
}

let globalTransferModel: CreditTransferState | undefined;
let transferModelDeferred = new Deferred<CreditTransferState>();

export function setTransferModel(model: CreditTransferState) {
    globalTransferModel = model;
    transferModelDeferred = new Deferred<CreditTransferState>();
    transferModelDeferred.resolve(model);
}

export async function getTransferModel(): Promise<CreditTransferState> {
    return transferModelDeferred.promise;
}

export interface CreditVoidState {
    creditId: string;
    sourceContactName: string;
    currentAmount: number;
    amount: number | null;
    note: string | null;
}

let globalVoidModel: CreditVoidState | undefined;
let voidModelDeferred = new Deferred<CreditVoidState>();

export function setVoidModel(model: CreditVoidState) {
    globalVoidModel = model;
    voidModelDeferred = new Deferred<CreditVoidState>();
    voidModelDeferred.resolve(model);
}

export async function getVoidModel(): Promise<CreditVoidState> {
    return voidModelDeferred.promise;
}
